import {
  Typography,
  Space,
} from 'antd';
import React from 'react';

import mapModifiers, { formatNumberWithSeparators } from 'common/utils/functions';

interface SummaryCardProps {
  title: string
  number: string | number
  variant?: 'tim-mach'
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title, number, variant
}) => (
  <div className={mapModifiers('t-summary-card', variant || '')}>
    <div className="t-summary-card_layers" />
    <Space className="t-summary-card_content" direction="vertical" style={{ width: '100%', justifyContent: 'space-between' }}>
      <Typography.Paragraph className="t-summary-card_title">{title}</Typography.Paragraph>
      <Typography.Paragraph className="t-summary-card_number">{formatNumberWithSeparators(Number(number))}</Typography.Paragraph>
    </Space>
  </div>
);

export default SummaryCard;
